module.exports = __webpack_public_path__ + "media/assets/images/landing/женщина-3f862a457161d1eb296183d0413c2e58.png";